// src/pages/Announcements.jsx
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FlowerDecor from "../components/common/FlowerDecor";
import { FiPhone, FiAlertTriangle, FiCheckCircle, FiGift, FiMessageCircle } from "react-icons/fi";

const Announcements = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white">
      <FlowerDecor />

      {/* HERO */}
      <section className="bg-[#e11d7b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
          <div className="max-w-3xl">
            <h1 className="text-2xl md:text-4xl font-extrabold leading-tight">
              🎫 Validité des Coupons
            </h1>
            <p className="mt-3 text-white/90 text-sm md:text-base">
              Informations importantes concernant vos coupons Maxula, contact et clause de responsabilité.
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/deals"
                className="inline-flex items-center justify-center px-5 py-3 rounded-xl bg-white text-[#e11d7b] font-semibold shadow"
              >
                Voir les deals
              </Link>
              <a
                href="tel:0606066162"
                className="inline-flex items-center justify-center px-5 py-3 rounded-xl bg-white/10 border border-white/30 text-white font-semibold hover:bg-white/15 transition"
              >
                Appeler
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-10 bg-[#fff3f8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* MAIN */}
            <div className="lg:col-span-2 space-y-6">
              {/* Card: Validité */}
              <div className="bg-white rounded-2xl shadow-sm border border-pink-100 p-6">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-pink-50 border border-pink-100 flex items-center justify-center shrink-0">
                    <FiCheckCircle className="text-[#e11d7b]" />
                  </div>
                  <div>
                    <h2 className="text-lg md:text-xl font-bold text-[#7a1147]">
                      🎫 Validité des Coupons
                    </h2>

                    <ul className="mt-3 space-y-2 text-gray-700">
                      <li className="flex gap-2">
                        <span className="text-[#e11d7b] font-bold">•</span>
                        <span>
                          Tous les coupons Maxula sont valables{" "}
                          <b>60 jours</b> à partir de la date d’achat.
                        </span>
                      </li>
                      <li className="flex gap-2">
                        <span className="text-[#e11d7b] font-bold">•</span>
                        <span>
                          Vous pouvez offrir le coupon <b>(excellent cadeau)</b>.
                        </span>
                      </li>
                      <li className="flex gap-2">
                        <span className="text-[#e11d7b] font-bold">•</span>
                        <span>
                          Après paiement, le <b>nom + les coordonnées</b> du partenaire seront envoyés automatiquement.
                        </span>
                      </li>
                      <li className="flex gap-2">
                        <span className="text-[#e11d7b] font-bold">•</span>
                        <span>
                          Tous les détails (adresse, conditions, validité) seront indiqués sur le coupon reçu par{" "}
                          <b>WhatsApp</b>.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Card: Contact */}
              <div className="bg-white rounded-2xl shadow-sm border border-pink-100 p-6">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-pink-50 border border-pink-100 flex items-center justify-center shrink-0">
                    <FiPhone className="text-[#e11d7b]" />
                  </div>
                  <div className="w-full">
                    <h2 className="text-lg md:text-xl font-bold text-[#7a1147]">
                      📞 Contact & Assistance
                    </h2>

                    <p className="mt-2 text-gray-700">
                      Pour plus d’informations ou conseils :
                    </p>

                    <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <a
                        href="tel:0606066162"
                        className="flex items-center justify-between gap-3 bg-[#fff3f8] border border-pink-100 rounded-xl px-4 py-3 hover:shadow-sm transition"
                      >
                        <span className="font-semibold text-[#7a1147]">0606 06 61 62</span>
                        <span className="text-sm text-gray-500">Appeler</span>
                      </a>

                      <a
                        href="tel:0539342494"
                        className="flex items-center justify-between gap-3 bg-[#fff3f8] border border-pink-100 rounded-xl px-4 py-3 hover:shadow-sm transition"
                      >
                        <span className="font-semibold text-[#7a1147]">0539 34 24 94</span>
                        <span className="text-sm text-gray-500">Appeler</span>
                      </a>
                    </div>

                    <div className="mt-4 flex items-center gap-2 text-sm text-gray-600">
                      <FiMessageCircle className="text-[#e11d7b]" />
                      <span>Disponible de <b>11h à 20h</b></span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card: Responsabilité */}
              <div className="bg-white rounded-2xl shadow-sm border border-pink-100 p-6">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-pink-50 border border-pink-100 flex items-center justify-center shrink-0">
                    <FiAlertTriangle className="text-[#e11d7b]" />
                  </div>
                  <div>
                    <h2 className="text-lg md:text-xl font-bold text-[#7a1147]">
                      ⚠ Clause de responsabilité
                    </h2>

                    <div className="mt-3 space-y-2 text-gray-700">
                      <p>
                        Maxula est un <b>city guide</b> et une plateforme de réservation.
                      </p>
                      <p>
                        Maxula décline toute responsabilité concernant les soins, résultats et conséquences.
                      </p>
                      <p>
                        Seul le partenaire est responsable des prestations réalisées.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* SIDE */}
            <aside className="space-y-6">
              <div className="bg-white rounded-2xl shadow-sm border border-pink-100 p-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-pink-50 border border-pink-100 flex items-center justify-center">
                    <FiGift className="text-[#e11d7b]" />
                  </div>
                  <h3 className="font-bold text-[#7a1147]">Conseil</h3>
                </div>
                <p className="mt-3 text-sm text-gray-700">
                  Pense à offrir un coupon Maxula : c’est rapide, pratique et idéal comme cadeau 🎁
                </p>

                <Link
                  to="/deals"
                  className="mt-4 inline-flex w-full items-center justify-center px-4 py-3 rounded-xl bg-[#e11d7b] text-white font-semibold hover:opacity-95 transition"
                >
                  Explorer les deals
                </Link>
              </div>

              <div className="bg-white rounded-2xl shadow-sm border border-pink-100 p-6">
                <h3 className="font-bold text-[#7a1147]">Rappel</h3>
                <p className="mt-2 text-sm text-gray-700">
                  Les détails (adresse, conditions, validité) sont sur le coupon envoyé par WhatsApp après paiement.
                </p>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Announcements;
